<div>
  <small class="my-5" [innerHTML]="'partner_setup_coupon_description' | translate"></small>
  <div class="page__form-wrap">
  <!-- read discount code -->
  <div *ngIf="!isShowBtnCreateDiscounCode">
    <div *ngFor="let promo of listDiscountCodes">
      <div class="form-group row custom-margin">
        <label for="code" class="col-sm-4" translate>partner_setup_coupon_input_label</label>
          <div class="col-sm-8">
            <input
            type ="text"
            [ngModel]="promo.discountCode"
            id="code"
            class="form-control text-opacity"
            readonly= true>
          </div>
      </div>
  </div>
</div>
  <!-- create discount code -->
  <div *ngIf="isShowBtnCreateDiscounCode">
    <div class="form-group row custom-margin">
      <label for="newCode" class="col-sm-4" translate>partner_setup_coupon_input_label</label>
        <div class="col-sm-8">
          <input
          type ="text"
          [formControl]="newDCodeControl"
          id="newCode"
          class="form-control">
        </div>
        <div class="col-sm-2">
          <button
          type="button"
          class="btn  btn-primary   btn-sm"
          (click)="addPromoCode()"
          translate>partner_setup_coupon_create_btn
          </button>
        </div>
  </div>

</div>
</div>
</div>



